<nf-grid-wrapper [hideSearch]="true" [hideClearAll]="true">
  <nf-grid-wrapper-header-left class="file-title header-size">
    <h2 class="title">External File Viewer</h2>
    <small *ngIf="_accountId">Account: {{ _accountId }}</small>
  </nf-grid-wrapper-header-left>

  <ng-grid-wrapper-header-right
    class="accounts-label header-size"
    *ngIf="aggAccountList.length > 1"
  >
    <small>Accounts</small>
  </ng-grid-wrapper-header-right>

  <ng-grid-wrapper-header-right
    *ngIf="aggAccountList.length > 1"
    class="header-size"
  >
    <nf-form-control class="account-select">
      <div *nfLoader="isSubAccountsLoading">
        <ng-select
          appendTo="body"
          [(ngModel)]="selectedAccount"
          [items]="aggAccountList"
          bindValue="id"
          bindLabel="name"
          [multiple]="true"
          [closeOnSelect]="false"
          placeholder="Select an account"
          [disabled]="false"
          clearAllText="Clear"
          [clearable]="!required"
          [clearOnBackspace]="true"
          [required]="required"
          groupBy="selectedAllGroup"
          [selectableGroup]="true"
          [selectableGroupAsModel]="false"
          (close)="loadSubAccountsFileData()"
          #selectedAccounts
        >
          <ng-template ng-multi-label-tmp let-items="items" let-clear="clear">
            <div
              *ngIf="items.length > 1; else singleItem"
              class="ng-value nf-custom-badge"
            >
              <span class="ng-value-label">
                {{ items.length }} accounts selected
              </span>
            </div>
            <ng-template #singleItem>
              <div class="ng-value nf-custom-badge">
                <span class="ng-value-label">
                  {{ items[0].id }} {{ items[0].name }}</span
                >
              </div>
            </ng-template>
          </ng-template>
          <ng-template
            ng-optgroup-tmp
            let-item="item"
            let-item$="item$"
            let-index="index"
          >
            <input
              id="item-{{ index }}"
              type="checkbox"
              [ngModel]="item$.selected"
            />
            Select All
          </ng-template>

          <ng-template
            ng-option-tmp
            let-item="item"
            let-item$="item$"
            let-index="index"
          >
            <input
              id="item-{{ index }}"
              type="checkbox"
              [ngModel]="item$.selected"
            />
            {{ item.id }}
            {{ item.name }}
          </ng-template>
        </ng-select>
      </div>
    </nf-form-control>
  </ng-grid-wrapper-header-right>
  <ng-grid-wrapper-header-right class="header-size">
    <nf-form-control class="form-class">
      <nf-daterange
        id="dateRange"
        [ngModel]="dateRange"
        (ngModelChange)="applyDateRange($event)"
        [beginDateRequired]="true"
        [endDateRequired]="true"
        [min]="minDate"
        [max]="maxDate"
      ></nf-daterange>
    </nf-form-control>
  </ng-grid-wrapper-header-right>
  <nf-grid-wrapper-content>
    <nf-table-layout
      [autoResizeGrid]="false"
      [isSectionTitle]="true"
      [gridOptions]="gridOptions"
      [data]="externalRawData"
      hideClearAll
      hideSearch
      [hideTitle]="true"
      *nfLoader="isExternalFileLoading"
    >
    </nf-table-layout> </nf-grid-wrapper-content
></nf-grid-wrapper>
